module.exports = __webpack_public_path__ + "static/media/ca_5.793239c3.png";